import { Component } from '@angular/core';

@Component({
  selector: 'app-improvement-items',
  standalone: true,
  imports: [],
  templateUrl: './improvement-items.component.html',
  styleUrl: './improvement-items.component.scss'
})
export class ImprovementItemsComponent {

}
